import { getMapStyle } from './map-style';
import { locationCellStatusStyle } from './location-cell-status-style';
import type { CommonStylesPalette } from '../types.d';


export const locationMapStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '& .location-manage-box': {
    width: 970,
    minHeight: '530px',
    border: `1px solid ${palette.neutralSecondary}`,
    float: 'left',
    color: palette.neutralPrimary,

    '& .left-panel': {
      width: 391,
      margin: '16px 36px 36px 30px',
      padding: 0,

      '& .recommend-location-grid .location-recommend-grid-container .table>thead>tr>th.recommendation-target-grid__removeall-header': {
        textAlign: 'right',
      },

      '& .location-search': {
        '& .searchbox': {
          borderBottom: '0 !important',
          color: palette.neutralSecondary,

          '& .searchbox-input': {
            border: `1px solid ${palette.neutralSecondary} !important`,
            width: 391,
            height: '32px',
            padding: '6px 8px 7px 32px',
          },

          '& .glyphicon': {
            left: 0,

            '& .searchbox-searchbutton': {
              position: 'absolute',
              width: 16,
              height: '16px',
              left: 8,
              top: 8,
              fontFamily: iconFontFamily,
              fontSize: 16,
              lineHeight: '16px',
              color: palette.themePrimary,
              pointerEvents: 'auto',
            },

            '& .searchbox-searchbutton:before': {
              content: '"\\E721"',
            },
          },
        },

        '& .new-location-targeting-prompt': {
          width: 360,
          height: '38px',
          lineHeight: '20px',
          color: palette.neutralSecondary,
        },

        '& .new-location-targeting-result': {
          border: 0,

          '& .new-location-targeting-container': {
            padding: 0,
            backgroundColor: palette.white,
            width: '100%',
            position: 'absolute',
            boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
            zIndex: 1,
            maxHeight: '444px',
            overflowY: 'auto',

            '& .new-location-targeting-grid': {
              fontSize: 14,
              width: '100%',

              '& .new-search-result-row': {
                lineHeight: '20px',

                '& .new-location-targeting-grid-include, .new-location-targeting-grid-exclude': {
                  padding: '8px 8px 8px 0',
                  textAlign: 'right',
                  color: palette.neutralSecondary,
                  verticalAlign: 'top',
                  minWidth: 80,

                  '& .new-location-targeting-separator': {
                    padding: '0 4px',
                    verticalAlign: 'baseline',
                  },
                },
              },

              '& .new-search-result-row>td': {
                padding: '8px 16px 9px 8px',
              },
            },

            '& .new-empty-result-message': {
              padding: '8px 8px 9px 8px',
              fontSize: 14,
            },
          },
        },
      },

      '& .location-target-grid, .excluded-location-target-grid': {
        position: 'relative',

        '& .no-data-message-container': {
          paddingTop: 8,
        },

        '& .target-grid-remove-all-locations': {
          position: 'absolute',
          right: 0,
          top: 0,
          padding: '8px 0px 8px 0',
        },

        '& .target-grid-remove-all-locations:after': {
          clear: 'both',
          display: 'table',
          content: '" "',
        },

        '& .location-popup-editor': {
          backgroundColor: palette.white,
          boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
          width: 375,
          height: 'auto',
          padding: '29px 17px 16px 17px',
          position: 'absolute',
          zIndex: 1,

          '& .radius-selector-table': {
            '& .radius-within': {
              width: 49,
              lineHieght: '19px',
            },

            '& .radius-input': {
              paddingLeft: 8,
              paddingRight: 12,

              '& .form-control': {
                width: 104,
                padding: '6px 8px 7px 8px',
              },
            },

            '& .radius-unit': {
              '& .form-control': {
                width: 104,
                padding: '6px 28px 7px 8px',
              },
            },
          },

          '& #radiusErrorValidationError': {
            margin: 0,
          },

          '& .location-edit-btn-done': {
            marginTop: 10,
          },

          '& .react-focus-lock': {
            '& .ba-backbone-instance-wrapper, .ba-backbone-instance-wrapper > div': {
              overflow: 'hidden',
            },
          },
        },

        '& .new-advance-target-grid-container': {
          '& .table-container': {
            width: 380,

            '& .table': {
              border: 0,
              '& .header': {
                borderBottom: `1px solid ${palette.neutralLight}`,
                '& .column-header': {
                  paddingLeft: 13,
                  border: '0 !important',
                  fontWeight: 'normal',
                  lineHeight: '19px',
                  height: '42px',
                  width: 336,
                  verticalAlign: 'middle',
                  '&:last-child': {
                    paddingRight: 0,
                    paddingLeft: 0,
                    width: 92,
                    textAlign: 'right',
                    wordBreak: 'normal',
                  },
                  '& >thead>tr>th .location-target-grid__removeall-header': {
                    textAlign: 'right',
                  },
                },

                '& .location-target-grid__remove-body': {
                  width: 44,
                },
              },

              '& .location-target-grid__area-row': {
                borderBottom: `1px solid ${palette.neutralLight}`,

                '& td': {
                  height: '32px',
                },

                '& span': {
                  verticalAlign: 'baseline',
                },

                '& .text-left': {
                  fontSize: 12,
                  lineHeight: '19px',
                  color: palette.neutralPrimary,
                  padding: '7px 5.5px 3px 13px',
                  border: 0,

                  '& .map-icon__pin--included, .map-icon__pin--excluded': {
                    display: 'inline-block',
                    fontFamily: iconFontFamily,
                    fontSize: 16,
                    color: '#107C10',
                    marginRight: 17,
                    lineHeight: '14px',
                    marginBottom: 5,
                    verticalAlign: 'middle',
                  },

                  '& .map-icon__pin--included:before': {
                    content: '"\\F5CB"',
                  },

                  '& .map-icon__pin--excluded': {
                    color: '#A80000',
                  },

                  '& .map-icon__pin--excluded:before': {
                    content: '"\\F5CE"',
                  },

                  '& .location-target-grid__title-column': {
                    color: palette.themePrimary,
                    cursor: 'pointer',
                    fontSize: 14,
                    position: 'relative',
                    fontWeight: 'bold',
                  },
                },

                '& .text-right': {
                  border: 0,
                  width: 12,
                  padding: '0 11px',

                  '& .location-target-grid__remove-col': {
                    width: 13,
                    height: '12px',
                    fontFamily: iconFontFamily,
                    fontSize: 12,
                    lineHeight: '12px',
                    textAlign: 'center',
                    color: palette.neutralSecondary,
                    verticalAlign: 'middle',
                  },
                  '& .location-target-grid__remove-col:before': {
                    content: '"\\E711"',
                  },
                },
              },
            },
          },
        },

        '& .pagination_host': {
          '& .pager': {
            display: 'inline-block',
            marginLeft: '0 !important',
          },
        },
        ...locationCellStatusStyle({ iconFontFamily }),
      },

    },

    '& .right-panel': {
      width: 485,
      height: '455px',
      margin: '16px 0 0 17px',
      padding: 0,

      '& .map': {
        height: '100%',
      },

      '& .map-container-wrapper': {
        height: '455px',

        '& .map-container': {
          extend: getMapStyle(palette)['& .map-container'],
          height: '455px',
          width: 485,
        },

        '& .map-message-panel': {
          extend: getMapStyle(palette)['& .map-message-panel'],
        },

      },
    },
  },

  '& .location-targets .control-label': {
    marginTop: 0,
  },


  '& a.disabled': {
    color: '#CCCCCC',
    cursor: 'default',
  },

  '& .location-manage .location-map-item': {
    display: 'flex',
    '& span': {
      wordBreak: 'break-word',
    },
  },

});
